import script from "./TileProjectDashboardBudgetThemes.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileProjectDashboardBudgetThemes.vue?vue&type=script&setup=true&lang=ts"

import "./TileProjectDashboardBudgetThemes.vue?vue&type=style&index=0&id=1a7ab018&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7ab018"]])

export default __exports__